export enum CampaignViolationType {
  PROHIBITION = 'PROHIBITION',
  BLOCKLIST = 'BLOCKLIST',
  DUPLICATION = 'DUPLICATION',
  JUXTAPOSITION = 'JUXTAPOSITION',
  PCE = 'PCE',
}

export type CampaignViolation = {
  type: CampaignViolationType;
  message: string;
};

export const CAMPAIGN_VIOLATION_ERROR_HEADER = 'Unable to save changes';

export const CAMPAIGN_VIOLATION_MULTIPLE_HEADER = 'This change creates multiple violations associated with:';

export const CAMPAIGN_VIOLATION_MULTIPLE_FOOTER = 'Your previous settings have been kept.';

export const CAMPAIGN_VIOLATION_LABEL: Record<CampaignViolationType, string> = {
  [CampaignViolationType.PROHIBITION]: 'Prohibition',
  [CampaignViolationType.BLOCKLIST]: 'Blocklist',
  [CampaignViolationType.DUPLICATION]: 'Duplication',
  [CampaignViolationType.JUXTAPOSITION]: 'Juxta',
  [CampaignViolationType.PCE]: 'PCE',
};
